export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq1',
    question: 'BB彩票平台正规吗？有没有合法资质？',
    answer: 'BB彩票平台持有国家相关部门颁发的合法彩票销售资质，所有彩票销售均严格遵守国家法律法规。平台资金由第三方银行全程托管，确保交易安全透明。您可以在关于我们页面查看完整的资质证书信息。',
  },
  {
    id: 'faq2',
    question: '中奖后奖金如何到账？多久能到？',
    answer: '小额奖金（1万元以下）在开奖后自动计入您的账户余额，可直接提现或继续购彩。大额奖金（1万元以上）会有专属客服人员联系您，协助办理兑奖手续，通常在1-3个工作日内完成到账。',
  },
  {
    id: 'faq3',
    question: '提现有手续费吗？支持哪些提现方式？',
    answer: 'BB彩票平台提现完全免费，不收取任何手续费。支持微信、支付宝和银行卡三种提现方式。提现金额最低10元起，单笔最高50万元，提现申请提交后通常在5分钟内到账。',
  },
  {
    id: 'faq4',
    question: '未成年人可以购买彩票吗？',
    answer: '不可以。根据《彩票管理条例》规定，未满18周岁的公民不得购买彩票。BB彩票平台严格执行实名认证制度，未满18岁的用户将无法完成实名认证，也无法进行任何购彩操作。',
  },
  {
    id: 'faq5',
    question: 'APP内购买彩票安全吗？个人信息会不会泄露？',
    answer: '非常安全。BB彩票APP采用银行级SSL加密技术，所有交易数据均经过多重加密处理。用户个人信息严格保密，仅用于必要的实名认证和兑奖服务，绝不会向任何第三方泄露。',
  },
  {
    id: 'faq6',
    question: '忘了登录密码怎么办？',
    answer: '您可以在登录页面点击"忘记密码"，通过注册手机号接收验证码来重置密码。如果遇到任何困难，也可以联系我们的24小时客服热线400-888-6666获取帮助。',
  },
  {
    id: 'faq7',
    question: '可以同时购买多期吗？支持追号功能吗？',
    answer: '可以。BB彩票APP支持多期投注和追号功能。双色球和大乐透支持最多连续投注15期，用户可以设置追号期数和是否在中奖后停止追号等选项，非常灵活便捷。',
  },
  {
    id: 'faq8',
    question: '中了奖需要缴税吗？',
    answer: '根据国家税收政策，单注中奖金额超过1万元（含）需要缴纳20%的个人偶然所得税。1万元以下的中奖金额免税。BB彩票平台会依法代扣代缴相关税费，您无需额外操作。',
  },
];